import React from 'react';
import PropTypes from 'prop-types';

import deliverService from '../../services/DeliveringService';
import navigationService from '../../services/NavigationService';
import sessionReader from '../../store/readHelpers/SessionReader';
import { t } from '../../services/i18nService';
import settingsReader from '../../store/readHelpers/SettingsReader';
import uiService from '../../services/UIService';

class DeliverButton extends React.Component {
    static propTypes = {
        buttonsDisabled: PropTypes.bool.isRequired,
        isOnline: PropTypes.bool.isRequired,
        timeHasExpired: PropTypes.bool.isRequired,
        ui: PropTypes.object,
        noAttemptedQuestions: PropTypes.bool,
    };

    navigateToFileDeliveryOptions = () => {
        if (sessionReader.userHasChromeKiosk()) {
            navigationService.navigateToOptionsFileDeliveryChromeApp();
        } else {
            navigationService.navigateToOptionsFileDelivery();
        }
    };

    finishPublicTest = () => {
        deliverService.resetExam();
    };

    navigateToRedirectURL = () => {
        navigationService.navigateToUrl(settingsReader.getRedirectUrl());
    };

    render() {
        const { buttonsDisabled, isOnline, timeHasExpired, ui, noAttemptedQuestions } = this.props;
        const showSubmitIcon = ui.variables.submit__showSubmitIcon;
        const submitIcon = showSubmitIcon ?
            <i className="fa fa-paper-plane-o fa-fw" aria-hidden="true" />
            : null;

        if (sessionReader.isAutoDeliveringEnabled() && isOnline) {
            if (noAttemptedQuestions && !timeHasExpired) {
                return null;
            }

            if (
                !sessionReader.isAutoDeliveringWithManualEnabled()
                && !timeHasExpired
            ) {
                return (
                    <button
                        id="backToDashboardButton"
                        className="btn btn--deliver"
                        onClick={navigationService.navigateToDashboardTicket}
                        disabled={buttonsDisabled}
                    >
                        {submitIcon}{t('delivering.backToDashboardAutoDeliverBtnText')}
                    </button>
                );
            }

            if (!sessionReader.isAutoDeliveringWithManualEnabled() || (sessionReader.isAutoDeliveringWithManualEnabled() && timeHasExpired)) {
                return (
                    <button
                        id="backToDashboardButton"
                        className="btn"
                        onClick={navigationService.navigateToDashboardTicket}
                        disabled={buttonsDisabled}
                    >
                        {submitIcon}{t('delivering.backToDashboard')}
                    </button>
                );
            }
        }

        if (sessionReader.isPublicExam()) {
            if (settingsReader.isRedirectUrlEnabled() && !!settingsReader.getRedirectUrl()) {
                const redirectButtonCaption = uiService.shouldUseSimplifiedSummaryPage()
                    ? t('delivering.famContextRedirectToURL')
                    : t('delivering.redirectToURL');

                return (
                    <button
                        id="redirectToUrlButton"
                        className="btn"
                        onClick={this.navigateToRedirectURL}
                        disabled={buttonsDisabled}
                    >
                        {submitIcon}{redirectButtonCaption}
                    </button>
                );
            }
            return (
                <button
                    id="reloadTestButton"
                    className="btn"
                    onClick={this.finishPublicTest}
                    disabled={buttonsDisabled}
                >
                    {submitIcon}{t('delivering.finishTest')}
                </button>
            );
        }

        if (isOnline) {
            return (
                <button
                    id="deliverTest"
                    className="btn btn--deliver"
                    onClick={deliverService.deliverTest}
                    disabled={buttonsDisabled}
                >
                    {submitIcon}{t('delivering.deliverTestButton')}
                </button>
            );
        }

        return (
            <button
                id="downloadOfflineDelivery"
                className="btn btn--deliver"
                onClick={this.navigateToFileDeliveryOptions}
                disabled={buttonsDisabled}
            >
                {submitIcon}{t('delivering.downloadOfflineDelivery')}
            </button>
        );
    }
}

export default DeliverButton;
